
import {ScrollDownService} from "./scroll-down.service";

export const ScrollDownInjectables: Array<any> = [
  {
    provide: ScrollDownService,
    useClass: ScrollDownService,
  },
];
